import { memo } from 'react';

import { CheckoutConfirmationResponseType } from 'src/models/Checkout/Confirmation';
import { useTHelper } from 'src/utils/i18n';
import { CheckoutConfirmationTable } from 'src/pages/Checkout/components/common/Table';
import { commonFormatCurrencyWithType } from 'src/utils/currency';

type Props = {
  model: CheckoutConfirmationResponseType['SaleItemsSubSection'];
};

export const CheckoutConfirmationSaleItems = memo<Props>(({ model }) => {
  const tHelper = useTHelper('checkout.confirmation.saleItems');

  const showOptionsColumn = model.Items.some((item) => item.AttributesSets.length);

  const columns = [
    { name: model.ItemsTerminology.Singular || '', className: 'left' },
    showOptionsColumn && { name: tHelper('options'), className: 'left' },
    { name: tHelper('price'), className: 'right' },
    { name: tHelper('quantity'), className: 'align-center' },
    { name: tHelper('total'), className: 'right' },
  ];

  return (
    <>
      <h2 className="section-header">{model.SectionHeader}</h2>
      <CheckoutConfirmationTable columns={columns} data={model.Items} customRow>
        {(item) => (
          <>
            {item.AttributesSets.length ? (
              item.AttributesSets.map((attributesSet) => (
                <tr key={item.Quantity}>
                  <td className="left">{item.ItemTitle}</td>
                  <td className="left">{attributesSet.Attributes.map((attribute) => attribute.Value).join(', ')}</td>
                  <td className="right">{commonFormatCurrencyWithType(item.Amount, model.CurrencyType)}</td>
                  <td className="align-center">{attributesSet.Quantity}</td>
                  <td className="right">
                    {item.Amount > 0
                      ? commonFormatCurrencyWithType(item.Amount * attributesSet.Quantity, model.CurrencyType)
                      : tHelper('free')}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td className="left">{item.ItemTitle}</td>
                {showOptionsColumn && <td className="left" />}
                <td className="right">{commonFormatCurrencyWithType(item.Amount, model.CurrencyType)}</td>
                <td className="align-center">{item.Quantity}</td>
                <td className="right">
                  {item.Amount * item.Quantity > 0
                    ? commonFormatCurrencyWithType(item.Amount * item.Quantity, model.CurrencyType)
                    : tHelper('free')}
                </td>
              </tr>
            )}
          </>
        )}
      </CheckoutConfirmationTable>
    </>
  );
});
